// 실적 임박 배지 — 대형주 한정(주요 촉매 종목). 정보 표시용이며 점수·시그널엔 미반영.
// 🎨 규격 V2(08-23) — 중립 칩(높이 18·반경 5). 임박(D-3 이내)일 때만 주의색.
export default function EarningsBadge({ dday }: { dday: number }) {
  const urgent = dday <= 3;
  return (
    <span
      className={`inline-flex items-center h-[18px] px-1.5 rounded-[5px] border text-[10.5px] font-medium shrink-0 whitespace-nowrap ${
        urgent
          ? 'border-dc-warn/40 bg-dc-warn/[0.08] text-dc-warn'
          : 'border-dc-line1 bg-dc-bg1 text-dc-ink2'
      }`}
      title={`다음 실적발표 D-${dday} — 발표 전후 변동성 주의 (점수엔 미반영)`}
    >
      실적 D-{dday}
    </span>
  );
}
